module.exports = __webpack_public_path__ + "img/monkey_business_illusion.0990e2ec.jpg";